import { Icon } from 'ant-design-vue'

const IconFont = {
  vm: {},
  // eslint-disable-next-line no-unused-vars
  install (Vue) {
    if (this.installed) {
      return
    }
    this.installed = true

    const IconFont = Icon.createFromIconfontCN({
      scriptUrl: '//at.alicdn.com/t/font_3287243_90fx1yzh856.js'
    })

    Vue.component('IconFont', IconFont)
  }
}

export default IconFont
